import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {tap} from "rxjs/internal/operators/tap";
import {catchError} from "rxjs/internal/operators/catchError";
import {EMPTY, Subscription} from "rxjs";
import {BroadcastingsService} from "../../../services/broadcastings-services/broadcastings.service";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";

@Component({
  selector: 'app-broadcastings-config-assignment-mode-card',
  templateUrl: './broadcastings-config-assignment-mode-card.component.html',
  styleUrls: ['./broadcastings-config-assignment-mode-card.component.scss']
})
export class BroadcastingsConfigAssignmentModeCardComponent implements OnInit, OnChanges {

  @Input() selectedMode;
  assignmentModes;
  basicDataForm = new FormGroup({
    selectedAssignmentMode: new FormControl(null, Validators.required),
  });
  updateAssignmentModeSubscription: Subscription;

  constructor(private broadcastingService: BroadcastingsService,
              private snackbarService: SnackBarService) {
    this.assignmentModes = Object.values(AssignmentModesEnum);
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.selectedMode && this.assignmentModes) {
      this.resetForm();
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      selectedAssignmentMode: this.selectedMode
    });
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  public updateAssignedMode(event) {
    console.log('update assigned mode with' + this.basicDataForm.get('selectedAssignmentMode').value);
    this.updateAssignmentModeSubscription = this.broadcastingService.updateBroadcastingsAssignmentModeConfig(
      this.basicDataForm.get('selectedAssignmentMode').value
    ).pipe(
      tap(o => this.broadcastingService.refreshConfig()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.updateAssignmentModeSubscription) { this.updateAssignmentModeSubscription.unsubscribe(); }
  }

}

export enum AssignmentModesEnum {
  'DEVICE_LEVEL' = 'DEVICE_LEVEL',
  'CENTER_LEVEL' = 'CENTER_LEVEL',
  'COMPANY_LEVEL' = 'COMPANY_LEVEL'
}
